<!--  -->
<template>
  <div class="myBody">
    <!-- 标题区域 -->
    <!-- <div class="title-section">
      <h3 class="main-title">Please Pay to This Account</h3>
    </div> -->

    <!-- 标题区域 -->
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/title_np02.png" class="title-image" />
      </div>
    </div>

    <!-- 银行信息面板 -->
    <div class="info-panel" v-if="orderInfo.orderId">
      <div class="info-row">
        <div class="info-label">Bank:</div>
        <div class="info-value">
          <span v-if="copyBankIf" class="copied">{{orderInfo.recBank}}</span>
          <span v-else>{{orderInfo.recBank}}</span>
        </div>
        <button @click="copyBank" class="copy-btn">Copy</button>
      </div>
      <div class="info-row">
        <div class="info-label">Receiver's:</div>
        <div class="info-value">
          <span v-if="copyOwnerIf" class="copied">{{orderInfo.recOwner}}</span>
          <span v-else>{{orderInfo.recOwner}}</span>
        </div>
        <button @click="copyOwner" class="copy-btn">Copy</button>
      </div>
      <div class="info-row">
        <div class="info-label">CardNo:</div>
        <div class="info-value">
          <span v-if="copyCardNoIf" class="copied">{{orderInfo.recCardNo}}</span>
          <span v-else>{{orderInfo.recCardNo}}</span>
        </div>
        <button @click="copyCardNo" class="copy-btn">Copy</button>
      </div>
      <div class="info-row">
        <div class="info-label">Amount:</div>
        <div class="info-value amount">
          <span v-if="copyAmountIf" class="copied">{{orderInfo.amount}}</span>
          <span v-else>{{orderInfo.amount}}</span>
        </div>
        <button @click="copyAmount" class="copy-btn">Copy</button>
      </div>
    </div>
    <!-- 操作区域 -->
    <div class="operation-panel" v-if="orderInfo.orderId">
      <div class="payment-steps">
        <p class="step-item">1. Enter Reference Code.</p>
        <p class="step-item">2. Upload a picture of your payment receipt image.</p>
      </div>
      <!-- 提交参考码 -->
      <div class="reference-input">
        <input type="text" v-model="rcode" placeholder="Enter Reference Code." class="rcode-input" />
        <button @click="rcodeSubmit()" class="submit-btn">Submit</button>
      </div>
      <!-- 上传凭证 -->
      <div class="upload-section">
        <input ref="file1" type="file" name="file1" class="file-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="fileSelected" />
        <button class="upload-btn" @click="fileOpen">
          Upload the payment receipt image
        </button>
      </div>
    </div>

    <!-- 倒计时组件 -->
    <div class="timer-wrapper">
      <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />
    </div>

    <!-- 订单ID组件 
    <div class="component-wrapper">
      <OrderIdComp :order-info="orderInfo" />
    </div>
    -->
    <!-- 时间提示组件 -->
    <div class="component-wrapper">
      <!-- <TimeTipsComp :order-info="orderInfo" /> -->
      <div class="tip-msg">
        <p>
          <span style="color:#4CAF50;"><b>{{$t("main['支付提示']")}}</b></span>:&nbsp;
          {{$t("main['请在']")}}<span style="color:red;">
            <font v-if="orderInfo.timePayLenSc">{{orderInfo.timePayLenSc}}</font>
            <font v-else>X</font>
          </span>{{$t("main['秒内']")}}{{$t("main['完成']")}}{{$t("main['支付']")}},
          {{$t("main['超时会自动']")}}<span style="color:rgb(25, 200, 223);">{{$t("main['取消']")}}</span>
        </p>
      </div>
    </div>
    <!-- 二维码支付选项 -->
    <div class="qr-panel" v-if="recQrUrlImg">
      <h4 class="qr-title">You can also try scan QrCode:</h4>
      <div class="qr-container">
        <div class="qr-image">
          <img :src="recQrUrlImg" class="qr-code" />
        </div>
        <div class="qr-instructions">
          <p class="instruction-step">1. Download and save the QR code image</p>
          <p class="instruction-step">2. Use APP to scan QR code and pay</p>
          <a class="download-btn" :href="recQrUrlImg" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`">
            Download QR Code
          </a>
        </div>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="notices-panel">
      <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Please do not pay beyond the time limit,</span> otherwise it cannot be recovered!!!</p>
      <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Please do not modify the amount,</span> otherwise it cannot be recovered!!!</p>
      <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Not checked before the next day,</span> cannot be recovered!!!</p>
      <p class="notice-item"><b>Notice:&nbsp;</b>Payment successful confirmation time: <span class="warning">5 to 10 minutes</span>, After payment, The account has not been received for more than <span class="warning">10 minutes,</span> Please contact customer service to check the order!</p>
    </div>

    <!-- 弹出确认框 -->
    <div class="modal" v-if="showMsg1">
      <div class="modal-content">
        <div class="modal-text" v-if="showMsg1Over">{{showMsg1Txt}}</div>
        <div class="modal-text" v-else>Please Wait ...</div>
        <button class="modal-close" @click="rcodeClose" v-if="showMsg1Over">Close</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as apis from "@/apis/apis";
//import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import QRCode from "qrcode";

export default {
  components: {
    //OrderIdComp,
    TimerComp2,
    // TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关状态
      copyBankIf: false,
      copyOwnerIf: false,
      copyAccountIf: false,
      copyCardNoIf: false,
      copyAmountIf: false,
      copyTranMarkIf: false,
      // 二维码相关
      recQrUrlImg: "",
      // 参考码
      rcode: "",
      // 弹窗状态
      showMsg1: false,
      showMsg1Txt: "Operation successful",
      showMsg1Over: false,
    };
  },
  methods: {
    init() {
      this.rcode = this.orderInfo.tranMark;
      // 生成二维码
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) return;
            this.recQrUrlImg = url;
          }
        );
      }
    },
    // 复制银行信息
    copyBank() {
      this.$parent.$parent.copySome(
        this.orderInfo.recBank,
        1,
        () => {
          this.copyBankIf = true;
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制收款人信息
    copyOwner() {
      this.$parent.$parent.copySome(
        this.orderInfo.recOwner,
        1,
        () => {
          this.copyOwnerIf = true;
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制卡号
    copyCardNo() {
      this.$parent.$parent.copySome(
        this.orderInfo.recCardNo,
        1,
        () => {
          this.copyCardNoIf = true;
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount() {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.copyAmountIf = true;
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制交易标记
    copyTranMark() {
      this.$parent.$parent.copySome(
        this.orderInfo.tranMark,
        2,
        () => {
          this.copyTranMarkIf = true;
        },
        () => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 提交参考码
    rcodeSubmit() {
      this.showMsg1 = true;
      this.showMsg1Over = false;
      apis
        .bkcd_np_rcode({
          id: this.orderInfo.orderId,
          rcode: this.rcode,
        })
        .then(() => {
          this.showMsg1Txt = "Reference Code submitted successfully！";
          this.showMsg1Over = true;
        });
    },
    // 关闭弹窗
    rcodeClose() {
      this.showMsg1 = false;
      this.showMsg1Over = false;
    },
    // 打开文件选择
    fileOpen() {
      this.$refs.file1.click();
    },
    // 处理选择的文件
    fileSelected(event) {
      const files = event.target.files;
      if (!files.length) return;

      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          // 图片压缩处理
          let maxSize = 800;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            height = maxSize * (height / width);
            width = maxSize;
          } else {
            width = maxSize * (width / height);
            height = maxSize;
          }

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.3);

          // 上传处理
          this.showMsg1 = true;
          this.showMsg1Over = false;
          apis
            .bkcd_np_cimg({
              id: this.orderInfo.orderId,
              cimg: dataUrl,
            })
            .then(() => {
              this.showMsg1Txt = "Image uploaded successfully!";
              this.showMsg1Over = true;
            });
        };
      };
    },
  },
};
</script>

<style scoped>
.myBody {
  background-color: #15172b;
}

/* 信息面板样式 */
.info-panel {
  background-color: #15172b;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 0.8rem;
  margin: 0.2rem 0;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 0.1rem 0;
  border-bottom: 1px solid #f1f1f1;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  flex: 0 0 100px;
  font-weight: 600;
  color: #eee;
  font-family: sans-serif;
  font-size: 0.85rem;
}

.info-value {
  flex: 1;
  font-size: 0.85rem;
  font-weight: 500;
  color: #3498db;
}

.info-value.amount {
  color: #e65f50;
}

.copied {
  color: #2df6ed;
}

.copy-btn {
  padding: 0.1rem 0.2rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s;
}

.copy-btn:hover {
  background: #2980b9;
}

.payment-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0.5rem;
  font-family: Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

/* 标题区域样式 */
.title-section {
  margin: 0.1rem 0;
  text-align: center;
  background-color: rgb(4, 51, 116);
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.01rem;
}

/* 图片百分比高度设置 */
.title-image {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.main-title {
  font-size: 1.2rem;
  color: #2c3e50;
  margin: 0;
}

/* 组件包裹器 */
.component-wrapper {
  margin: 0.1rem 0;
  padding: 0.3rem;
  background-color: #15172b;
  border-radius: 5px;
  color: white;
}

.timer-wrapper {
  border-left: 4px solid #e74c3c;
}

/* 操作面板样式 */
.operation-panel {
  background-color: #15172b;
  background: #2c3e50;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.8rem;
  margin: 0.2rem 0;
}

.payment-steps {
  margin-bottom: 0.2rem;
}

.step-item {
  margin: 0.1rem 0;
  font-size: 0.9rem;
  color: white;
}

.reference-input {
  display: flex;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
}

.rcode-input {
  flex: 1;
  padding: 0.2rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
}

.submit-btn {
  padding: 0.5rem 1.2rem;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.3s;
}

.submit-btn:hover {
  background: #219653;
}

.upload-section {
  text-align: center;
}

.file-input {
  visibility: hidden;
  width: 0;
  height: 0;
}

.upload-btn {
  padding: 0.5rem 1.5rem;
  background: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.3s;
  width: 100%;
}

.upload-btn:hover {
  background: #e67e22;
}

/* 二维码面板样式 */
.qr-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.2rem;
  margin: 0.5rem 0;
}

.qr-title {
  font-size: 1.1rem;
  color: #27ae60;
  margin-top: 0;
  margin-bottom: 1rem;
}

.qr-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: center;
}

.qr-image {
  flex: 0 0 200px;
  text-align: center;
}

.qr-code {
  width: 100%;
  max-width: 200px;
  height: auto;
}

.qr-instructions {
  flex: 1;
}

.instruction-step {
  margin: 0.8rem 0;
  font-size: 0.9rem;
  color: #555;
}

.download-btn {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: #3498db;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: background 0.3s;
}

.download-btn:hover {
  background: #2980b9;
}
/* 注意事项样式 */
.notices-panel {
  background-color: #15172b;
  border-radius: 20px;
  padding: 0.8rem;
  margin: 0.2rem 0;
  border: 1px solid #ffebee;
}

.notice-item {
  margin: 0.7rem 0;
  font-size: 0.9rem;
  color: white;
}

.warning {
  color: #e74c3c;
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  width: 90%;
  max-width: 400px;
}

.modal-text {
  font-size: 1.1rem;
  margin-bottom: 1.2rem;
  color: #333;
}

.modal-close {
  padding: 0.5rem 1.2rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s;
}

.modal-close:hover {
  background: #2980b9;
}

/* 响应式调整 */
@media (max-width: 600px) {
  .payment-container {
    padding: 1rem;
  }

  .info-row {
    flex-wrap: wrap;
  }

  .info-label {
    flex: 0 0 100% !important;
    margin-bottom: 0.1rem;
  }

  .qr-container {
    flex-direction: column;
  }

  .reference-input {
    flex-direction: column;
  }

  .submit-btn {
    width: 100%;
  }

  .title-section {
    height: 50px;
  }
  .title-image {
    height: 100%;
  }
}
</style>